import { render, staticRenderFns } from "./ModalLoginSocial.vue?vue&type=template&id=0b8b2b3c&scoped=true"
import script from "./ModalLoginSocial.vue?vue&type=script&lang=js"
export * from "./ModalLoginSocial.vue?vue&type=script&lang=js"
import style0 from "./ModalLoginSocial.vue?vue&type=style&index=0&id=0b8b2b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b2b3c",
  null
  
)

export default component.exports